import React from "react";
import { Link } from 'react-router-dom';
import appLogo from "../assets/Guide_uni_logo.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Navbar = () => {
  return (
    <div className="header">
      <div className="header-top"></div>
      <div className="container-fluid">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src={appLogo} alt="FlyUrDream Logo" height="40" />
              </Link>

              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link active" to="/universities">Universities</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/recruiters">Recruiters</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/aggregators">Aggregators</Link>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}
                    >
                      Company
                    </a>

                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <Link className="dropdown-item" to="/how-it-works">
                          How It Works
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/blog">
                          Blog
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/about">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/career">
                          Careers
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/contact">
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link ext-link" to="https://crm.guideuni.com/">Login</Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;